







































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { Location } from "vue-router";
import Users from "@/admin/components/shared/Users.vue";
import { UserSearchResultModel } from "@/admin/types";
import Button from "@/shared/components/ui/Button.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUtilityStore } from "@/admin/store/utility";

@Component({
  components: {
    Button,
    Users
  }
})
export default class AdminUtilityUserEnableDisableAccount extends Vue {
  notifierStore = useNotifierStore();
  utilityStore = useUtilityStore();

  emailAddress = "";
  isLoaded = false;
  showConfirmEnableModal = false;
  showConfirmDisableModal = false;
  refreshData = false;                // tells the child component to refresh its data
  refreshDelayInMiliseconds = null;   // stored the delay in miliseconds until the refresh triggers

  @Prop()
  page: number;

  @Prop()
  routeToUserList: (page: number) => Location;

  mounted () {
    this.initialize();
  }

  initialize () {
    this.emailAddress = "";
    this.isLoaded = true;
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.refreshData = false;
    this.showError(
      (err && err.errorMessage) ||
      "Error processing your request. Please try again later"
    );
  }

  determineWhichModalToDisplay (user: UserSearchResultModel) {
    if (user.isConfirmed) {
      this.showConfirmDisableAccount(user);
    }
    else {
      this.showConfirmEnableAccount(user);
    }
  }

  cancelEnableAccount () {
    this.refreshData = false;
    this.showConfirmEnableModal = false;
    this.emailAddress = "";
  }

  cancelDisableAccount () {
    this.refreshData = false;
    this.showConfirmDisableModal = false;
    this.emailAddress = "";
  }

  showConfirmEnableAccount (user: { email: string } ) {
    this.emailAddress = user.email;
    this.showConfirmEnableModal = true;
  }

  showConfirmDisableAccount (user: { email: string }) {
    this.emailAddress = user.email;
    this.showConfirmDisableModal = true;
  }

  confirmEnableAccount () {
    const email = this.emailAddress;
    this.utilityStore.enableAccount({
      emailAddress: email
    })
    .then(result => {
        this.notifierStore.setSuccess(`Enabled ${result.enabledBendUsers.length} Bend account${result.enabledBendUsers.length === 1 ? "" : "s"}
        and ${result.foundCognitoUsers.length} Cognito account${result.foundCognitoUsers.length === 1 ? "" : "s"} matching ${email}`);
      })
      .catch(this.handleError);

    clearTimeout(this.refreshDelayInMiliseconds);
    this.refreshDelayInMiliseconds = setTimeout(() => {
      this.refreshData = true;
    }, 1000);

    this.showConfirmEnableModal = false;
    this.emailAddress = "";
  }

  confirmDisableAccount () {
    const email = this.emailAddress;
    this.utilityStore.disableAccount({
      emailAddress: email
    })
      .then(result => {
        this.notifierStore.setSuccess(`Disabled ${result.disabledBendUsers.length} Bend account${result.disabledBendUsers.length === 1 ? "" : "s"}
        and ${result.foundCognitoUsers.length} Cognito account${result.foundCognitoUsers.length === 1 ? "" : "s"} matching ${email}`);
      })
      .catch(this.handleError);

    clearTimeout(this.refreshDelayInMiliseconds);
    this.refreshDelayInMiliseconds = setTimeout(() => {
      this.refreshData = true;
    }, 1000);

    this.showConfirmDisableModal = false;
    this.emailAddress = "";
  }

  onClose () {
    this.refreshData = false;
    this.showConfirmDisableModal = false;
    this.emailAddress = "";
  }
}
